import { SETTINGS_STORE, run } from "./db";

const KEY = "offline-user";

/**
 * Tells the service worker whose answers it is caching (US-33.4).
 *
 * <p>Two ways, because the worker forgets and the message is one-way: a `postMessage` for the worker
 * running right now, and a row in the database for the one the browser starts tomorrow morning. The
 * worker reads that row when it has no sub in memory; with neither, it caches nothing at all, which
 * is the safe end of the trade on a shared tablet.
 *
 * <p>Not `localStorage`: a service worker cannot read it.
 */
export async function rememberSubForWorker(sub: string | undefined): Promise<void> {
  try {
    if (sub) {
      await run(SETTINGS_STORE, "readwrite", (store) => store.put(sub, KEY));
    } else {
      await run(SETTINGS_STORE, "readwrite", (store) => store.delete(KEY));
    }
  } catch {
    // Storage off: the worker will simply not cache API answers for this device.
  }
  navigator.serviceWorker?.controller?.postMessage({ type: "OFFLINE_USER", sub });
}
